<template>
  <div id="app">
    <router-view></router-view>
    <div
      class="footer"
      v-if="$route.name !== 'Login' && $route.name !== 'Register'"
    >
      {{ $store.state.phone }}
    </div>
    <div class="footer"></div>
    <Loading/>
  </div>
</template>

<script>
import Loading from '@cmp/Loading/index.vue'
export default {
  name: "App",
  components:{
    Loading
  }
};
</script>

<style lang="less" scoped>
.footer {
  text-align: right;
  font-size: 15px;
  padding-right: 20px;
}
:deep(.el-button--primary) {
  background-color: #00c292;
  border-color: #00c292;
}
:deep(.el-select .el-input__inner:focus),
:deep(.el-input__inner:focus) {
  border-color: #00c292 !important;
}
:deep(.el-select-dropdown__item.selected) {
  color: #00c292;
}
:deep(.el-input__inner) {
  width: 520px;
  height: 60px;
  border-radius: 13px;
  font-size: 18px;
  color: #737b87;
}
:deep(.el-form--label-top .el-form-item__label) {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}
:deep(.el-button--primary) {
  width: 520px;
  height: 60px;
  background-color: #00c292;
  border-color: #00c292;
  border-radius: 30px;
  margin: 20px 0;
  font-size: 18px;
}
:deep(.el-button--primary:hover) {
  background-color: #02e0a9;
  border-color: #02e0a9;
}
:deep(.el-button--primary:active),
:deep(.el-button--primary:focus) {
  background-color: #00c292;
  border-color: #00c292;
}
:deep(.el-form-item__error) {
  font-size: 16px;
}
:deep(.el-dialog__headerbtn) {
  font-size: 20px;
}
</style>
